import { Component, OnInit, Input, EventEmitter, Output, HostListener, ViewChild, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { Timeline } from './timeline.model';
import * as _ from 'lodash';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeNl from '@angular/common/locales/nl';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'af-timeline',
    template: ''
})
export class TimelineComponent implements OnInit {


    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public dayBefore: number = -1;


    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public dayAfter: number = -1;


    @Input()
    public dateBefore: Date = new Date();


    @Input()
    public dateAfter: Date = moment().add(1, 'month').toDate();

    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public dateDisplayFormat: string = 'dd/MM/yyyy';

    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public dateDisplayMonthFormat: string = 'LLLL';

    @Input()
    public selectedDate: Date;

    @Output()
    public selectedDateChange: EventEmitter<Date> = new EventEmitter<Date>();


    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public isActiveClass: string = 'active';

    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public isTodayClass: string = 'today';
    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public isPastClass: string = 'past';

    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public isWeekEndClass: string = 'weekend';


    @ViewChild('mainTimeLine')
    private mainTimelineContainer: ElementRef;

    public timelineModel: any;

    @Input()
    // tslint:disable-next-line:no-inferrable-types
    public local: string = 'fr';

    @Input()
    public command: any;

    constructor() {
        registerLocaleData(localeFr);
        registerLocaleData(localeEn);
        registerLocaleData(localeNl);
    }

    ngOnInit() {
        if (this.dayBefore > -1) {
            this.dateBefore = moment().subtract(this.dayBefore, 'days').toDate();
        }

        if (this.dayAfter > -1) {
            this.dateAfter = moment().add(this.dayAfter, 'days').toDate();
        }

        // tslint:disable-next-line:curly
        if (!this.dateAfter || !this.dateBefore)
            throw new Error('Invalid dates');

        this.generateTimelineRange();
    }

    public setSelectedDate(dateSelected: Date) {
        this.selectedDate = dateSelected;
        this.selectedDateChange.emit(this.selectedDate);

        if (this.command) {
            this.command();
        }
    }

    private generateTimelineRange() {

        let now = moment(this.dateBefore);
        const dates = [];

        while ((now.isAfter(this.dateBefore) || now.isSame(this.dateBefore))
            && (now.isBefore(this.dateAfter) || now.isSame(this.dateAfter))) {
            dates.push(now.toDate());
            now = now.add(1, 'days');
        }

        this.timelineModel = _.groupBy(dates, (e: any) => {
            return new Date(moment(e).year(), moment(e).month());
        });
    }

    public getListOfMonth() {
        return Object.keys(this.timelineModel);
    }

    public getDateClass(date: Date) {
        // tslint:disable-next-line:no-inferrable-types
        let classToDate: string = '';


        if (moment(date).isSame(moment(), 'day')) {
            classToDate += this.isTodayClass;
        }

        if (moment(date).isSame(moment(this.selectedDate), 'day')) {
            classToDate += ' ' + this.isActiveClass;
        }

        if (moment(date).isBefore(moment(), 'day')) {
            classToDate += ' ' + this.isPastClass;
        }

        if (date.getDay() === 6 || date.getDay() === 0) {
            classToDate += ' ' + this.isWeekEndClass;
        }

        return classToDate;
    }

    public leftAction(delta: number = 300) {
        this.mainTimelineContainer.nativeElement.scrollLeft += (delta * -1 / 2);
    }

    public rightAction(delta: number = -300) {
        console.log('Right action triggered: ', delta);
        console.log('MainTimelineContainer: ', this.mainTimelineContainer);
        console.log('MainTimelineContainer native element: ', this.mainTimelineContainer.nativeElement);
        console.log('MainTimelineContainer native element scrollLeft: ', this.mainTimelineContainer.nativeElement.scrollLeft);
        this.mainTimelineContainer.nativeElement.scrollBy((delta * -1 / 2), 0);
        //this.mainTimelineContainer.nativeElement.scrollLeft += (delta * -1 / 2);
        console.log('MainTimelineContainer native element after scrollLeft: ', this.mainTimelineContainer.nativeElement.scrollLeft);
    }

    @HostListener('wheel', ['$event'])
    private onScroll(event: WheelEvent) {
        this.mainTimelineContainer.nativeElement.scrollLeft += event.deltaY * -1;
        event.preventDefault();
    }
}
